<div>
Da li ste sigurni da želite da obrišete oznaku  <strong>{{oznaka.punNaziv ?? oznaka.naziv}}</strong> ?
</div>
